module.exports = {"data":{"site":{"siteMetadata":{"title":"Dr. Jonathan Blake Huer","description":"Dr. Jonathan Blake Huer is currently a leader in academic technology, emerging technologies, disruptive innovation, higher education, global education policy, product development, digital entreprenuership, and media. He has won numerous awards as an educator, innovator, administrator, mobile app developer, and filmmaker."}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 123
// module chunks = 60335399758886 114276838955818